import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "ppusa_cart";

const lineKey = (i) => `${i.product_id}__${i.size || ""}__${i.color || ""}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });
  const [promo, setPromoState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY + "_promo")) || null; } catch { return null; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY + "_promo", JSON.stringify(promo));
  }, [promo]);

  const setPromo = (p) => setPromoState(p);
  const clearPromo = () => setPromoState(null);

  const addItem = (item) => {
    setItems((prev) => {
      const key = lineKey(item);
      const existing = prev.find((i) => lineKey(i) === key);
      if (existing) {
        return prev.map((i) => (lineKey(i) === key ? { ...i, quantity: i.quantity + (item.quantity || 1) } : i));
      }
      return [...prev, { ...item, quantity: item.quantity || 1 }];
    });
    setOpen(true);
  };

  const updateQty = (key, qty) => {
    if (qty < 1) return removeItem(key);
    setItems((prev) => prev.map((i) => (lineKey(i) === key ? { ...i, quantity: qty } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => lineKey(i) !== key));
  const clear = () => { setItems([]); setPromoState(null); };

  const count = items.reduce((n, i) => n + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const discount = !promo ? 0 : promo.type === "percent"
    ? Math.round(subtotal * promo.value) / 100
    : Math.min(promo.value, subtotal);
  const total = Math.max(0, subtotal - discount);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal, discount, total, promo, setPromo, clearPromo, open, setOpen, lineKey }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
